// extracted by mini-css-extract-plugin
export default {"clickable":"l7X1gj96i8bVp3SQQjBu"};